export const CART_ACTION_TYPES = {
    SET_CART_ITEMS: 'cart/SET_CART_ITEMS',
    SET_CART_IS_OPEN: 'cart/SET_CART_IS_OPEN'
};